<template>
    <div class="device">
        <div class="deviceTitle">
            Detachable Pump Head
        </div>
        <div class="picBox">
            <img src="@/assets/index/panda-bear.png" alt="" />
        </div>
        <div class="detailText">
            Closed irrigation system directly connected to the irrigation fluid for convenience and efficiency.
        </div>
    </div>
</template>

<script>

export default {
    components: {

    },
    data() {
        return {

        }
    },
    created() {

    },
    mounted() {

    },
    methods: {

    }
}
</script>

<style scoped lang="scss">
.device {
    padding-bottom: 100px;
    background: #ffffff;

    .deviceTitle {
        margin: auto;
        width: 1200px;
        font-size: 40px;
        color: #000000;
    }

    .picBox {
        width: 1200px;
        margin: auto;
        margin-top: 38px;

        img {
            width: 100%;
            height: 700px;
            object-fit: cover;
        }
    }

    .detailText {
        width: 1200px;
        margin: auto;
        margin-top: 50px;
        font-weight: 400;
        font-size: 21px;
        line-height: 28px;
        color: #000000;
    }
}

@media screen and (max-width:1200px) {}
</style>